import { z } from 'zod'
import {
  addressEditItemSchema,
  type AddressEditItem,
} from '@/shared/schemas/addressEditSchema'

export const updateBusinessSchema = z
  .object({
    legalName: z.string().trim().min(3, 'Mínimo 3 caracteres').max(80, 'Máximo 80 caracteres'),
    logo: z.string().trim().max(500).optional().or(z.literal('')),
    addresses: z.array(addressEditItemSchema),
  })
  .superRefine((val, ctx) => {
    const active = val.addresses.filter((a) => !a._deleted)
    if (active.length === 0) {
      ctx.addIssue({
        code: 'custom',
        path: ['addresses'],
        message: 'El negocio debe tener al menos una dirección',
      })
    }
  })

export type UpdateBusinessFormValues = z.infer<typeof updateBusinessSchema>
export type UpdateBusinessAddressItem = AddressEditItem
